
import React from "react";
import { AdminSettings } from "@/types/adminSettings";
import { SmsNotificationsTab } from "./SmsNotificationsTab";

interface SmsSettingsTabProps {
  settings: AdminSettings;
  updateSettings: (path: string[], value: any) => void;
  saveSettings: () => Promise<void>;
  isSaving: boolean;
}

export const SmsSettingsTab = ({ settings, updateSettings, saveSettings, isSaving }: SmsSettingsTabProps) => {
  return (
    <SmsNotificationsTab 
      settings={settings}
      updateSettings={updateSettings}
      saveSettings={saveSettings}
      isSaving={isSaving}
    />
  );
};
